export const theme = {
  colors: {
    primary: '#0f2d3c',

    text: {
      primary: '#50575a'
    }
  }
};

export default theme;